import { useNavigation } from "@react-navigation/native";
import { useCallback } from "react";

import { LoginForm } from "../components";

export function LoginScreen() {
  // Vars
  const navigation = useNavigation();

  // Handlers
  const goToLoginOtp = useCallback(
    (email: string | null, emailVerified: boolean, phone: string) => {
      navigation.navigate("LoginOtp", { email, emailVerified, phone });
    },
    [navigation],
  );

  // Render
  return <LoginForm onSuccess={goToLoginOtp} />;
}
